import React from "react";
import { FieldConfig, FieldSectionConfig } from "../../../../../models/Models";
import EditModal from "../modal/EditModal";
import { Content } from "../../../../../models/vod/Models";
import { useEditVodContent } from "../../../../../services/vod/Query";

interface Props {
    modalId: string;
    content: Content;
}

const ContentModal = ({ content, modalId }: Props) => {
    const editVodContent = useEditVodContent();
    const contentFormConfig: FieldConfig<Content>[] = [
        { path: "title", label: "Title", type: "text" },
        {
            path: "classification",
            type: "group",
            fields: [
                { path: "categories", label: "Categories", type: "text", isArray: true },
                { path: "genres", label: "Genres", type: "text", isArray: true },
                { path: "keywords", label: "Keywords", type: "text", isArray: true },
            ],
        },
        {
            path: "summaries",
            type: "group",
            fields: [
                { path: "longSynopsis", label: "Long synopsis", type: "paragraph" },
                { path: "mediumSynopsis", label: "Medium synopsis", type: "paragraph" },
                { path: "shortSynopsis", label: "Short synopsis", type: "paragraph" },
            ],
        },
        {
            path: "releaseInfo",
            type: "group",
            fields: [
                { path: "yearOfRelease", label: "Year of Release", type: "number" },
                { path: "countriesOfOrigin", label: "Countries of Origin", type: "text", isArray: true },
            ],
        },
        {
            path: "videoAsset",
            type: "group",
            fields: [
                { path: "languages", label: "Languages", type: "text", isArray: true },
            ],
        },
        {
            path: "parentalRatings",
            label: "Parental Ratings",
            type: "group",
            isArray: true,
            fields: [
                { path: "region", label: "Region", type: "text" },
                { path: "system", label: "System", type: "text" },
                { path: "label", label: "Label", type: "text" },
                { path: "advisories", label: "Advisories", type: "text", isArray: true },
            ],
        },
        {
            path: "castAndCrew",
            type: "group",
            fields: [
                { path: "actors", label: "Actors", type: "text", isArray: true },
                { path: "directors", label: "Directors", type: "text", isArray: true },
                { path: "producers", label: "Producers", type: "text", isArray: true },
            ],
        },
    ];
    const fieldSectionConfigs: FieldSectionConfig<Content>[] = [ {
        fields: contentFormConfig,
    } ];
    return (
        <>
            <EditModal
                modalId={modalId}
                config = {fieldSectionConfigs}
                initialValues = {content}
                onSubmit = {async (data: Content) => {
                    await editVodContent.mutateAsync(data);
                }}
            />
        </>
    );
};

export default ContentModal;